import React, { useState, useEffect } from 'react';
import R from 'ramda';

import { useDispatch, useSelector } from 'react-redux';

import { push } from 'connected-react-router';
import { useRouteMatch } from 'react-router-dom';

import Title from 'react-bulma-companion/lib/Title';
import Button from 'react-bulma-companion/lib/Button';
import Input from 'react-bulma-companion/lib/Input';

import { formatPhoneNumFromInput } from '_utils/functions';

import { attemptLogin, attemptRegister } from '_thunks/auth';

import { postCheckUsername } from '_api/users';
import { sendPhoneVerification, checkPhoneVerificationCode } from '_api/auth';

import SubInfo from '_molecules/SubInfo';

import useKeyPress from '_hooks/useKeyPress';

export default function PhoneAuth() {
    const dispatch = useDispatch();

    const { path, url } = useRouteMatch();

    const { user } = useSelector(R.pick(['user']));

    const [phone, setPhone] = useState('');
    const [isVerifying, setIsVerifying] = useState(false);

    const [code, setVerifyCode] = useState('');

    const [error, setError] = useState('');

    const [usernameMessage, setUsernameMessage] = useState('');
    const [usernameAvailable, setUsernameAvailable] = useState(true);

    const hashPass = () => {
        return phone;
    }

    const updatePhone = e => {
        setPhone(formatPhoneNumFromInput(e));
    }

    const changePhone = e => {
        setError('');
        setPhone(e.target.value)
    }

    const changeVerifyCode = e => {
        setError('');
        setVerifyCode(e.target.value)
    }

    const login = async (username, then) => {
        let password = hashPass();
        const userCredentials = { username, password };

        await dispatch(attemptLogin(userCredentials));
        
        return;
    };

    const verifyCode = () => {
        checkPhoneVerificationCode({ phone, code })
            .then(res => {
                if (res.status == "approved") {
                    login(phone, () => { });
                    dispatch(push(`/s/intake/router`));
                } else {
                    if (res.status == "429" || res.status == '60202') {
                        setError('You\'ve entered too many wrong codes, is ' + phone + ' your correct cell number?'); //TODO We should text them to remind them in 10 minutes
                    } else if (res.reason == "Code Expired") {
                        setError('You\'re code has expired, we\'re sending a new one.');
                        sendPhoneVerification({ phone });
                    } else {
                        setError('It seems your code is not right.');
                    }
                }
            })
    }

    const next = () => {
        if (phone == '') {
            setError('Please enter your phone number');
        } else if (phone.length < 14) {
            setError('Please enter a valid US phone number');
        } else {
            postCheckUsername(phone)
                .then(res => {
                    if (res.available) { //If does not exist as client phone number (client's usernames are phone number)
                        dispatch(push(`${path}email`));
                    } else {
                        sendPhoneVerification({ phone });
                        setIsVerifying(true);
                    }
                })
                .catch((e) => { console.log(e) });
        }
    }

    useKeyPress('Enter', next);

    return (
        <>
            <Title size="3">
                {isVerifying ? <>We just sent you a text.</> : <>Enter Your Phone Number:</>}
            </Title>
            <div className="input-group short-answer">
                <input type="tel" id="phone" autoFocus onChange={changePhone} onKeyUp={updatePhone} value={phone} maxLength="14" placeholder='(555) 555-5555' name="phone" />
                <p>{usernameMessage}</p>
                <div className='clearfix' />
                {isVerifying &&
                    <>
                        <input type="tel" id="code" onChange={changeVerifyCode} value={code} maxLength="6" placeholder='Enter Code' name="code" />
                        <a className="" style={{ width: "100%" }} onClick={() => { sendPhoneVerification({ phone }); setError('We\'re sending a new code to ' + phone) }}>Haven't recieved a code?</a>
                    </>}
            </div>
            {
                isVerifying ?
                    <Button className="next-btn" disabled={code.length < 6} onClick={verifyCode}>
                        Verify Code
                    </Button> :
                    <Button className="next-btn" onClick={next}>
                        Log In
                    </Button>
            }
            <p className="err">{error}</p>
        </>
    );
}